









import Vue from 'vue'
export interface MiembrosComponentData {
  images: string[]
}

export default Vue.extend({
  data: (): MiembrosComponentData => ({
    images: [
      '/images/logos/logo1.png',
      '/images/logos/logo2.png',
      '/images/logos/logo3.png',
      '/images/logos/logo4.png',
      '/images/logos/logo5.png',
      '/images/logos/logo6.png',
      '/images/logos/logo7.png',
      '/images/logos/logo8.png',
      '/images/logos/logo9.png',
      '/images/logos/logo10.png',
      '/images/logos/logo11.png',
      '/images/logos/logo12.png',
      '/images/logos/logo13.png',
      '/images/logos/logo14.png',
      '/images/logos/logo15.png',
      '/images/logos/logo16.png',
      '/images/logos/logo17.png',
      '/images/logos/logo18.png',
      '/images/logos/logo19.png',
      '/images/logos/logo20.png',
      '/images/logos/logo21.png',
      '/images/logos/logo22.png',
      '/images/logos/logo23.png',
      '/images/logos/logo24.png',
    ],
  }),
})
